// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a47bb58e","455":"0c409a51","977":"52254204"}[chunkId] + ".chunk.js";
};